export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-16">
            戦略設計と技術実装で支えるWeb制作
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white border border-gray-200 p-8 rounded-xl shadow-sm">
              <div className="w-16 h-16 bg-cta rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shopping-cart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-4">売れる導線を設計するShopify構築</h3>
              <p className="text-gray-700 leading-relaxed">
                BtoB・BtoCを一つのサイトで運用。<br />
                会員価格設定やログイン制御にも対応します。
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                EC-CUBEや楽天からの移行、<br />
                多言語対応などもご相談ください。
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-8 rounded-xl shadow-sm">
              <div className="w-16 h-16 bg-navy-light rounded-lg flex items-center justify-center mb-6">
                <i className="ri-global-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-4">強みを伝え、問い合わせにつなげる企業サイト制作</h3>
              <p className="text-gray-700 leading-relaxed">
                単なるデザインではなく、<br />
                「自社の強みを伝える構成」と<br />
                「問い合わせにつながる導線設計」を重視します。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}